import { render, staticRenderFns } from "./ShowDashboard.vue?vue&type=template&id=03c3e578&scoped=true"
import script from "./ShowDashboard.vue?vue&type=script&lang=js"
export * from "./ShowDashboard.vue?vue&type=script&lang=js"
import style0 from "./ShowDashboard.vue?vue&type=style&index=0&id=03c3e578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c3e578",
  null
  
)

export default component.exports